import React, { FC, useState } from 'react';
import { Button, Input, InputPassword, LoginLogo, Version } from '@components';
import { onChangeWithValidation, validator } from '@helpers';
import { setClass, useViewModel } from '@utils';
import { observer } from 'mobx-react-lite';
import { ProfileViewModel } from '../profilePage';
import { LoginViewModel } from './LoginViewModel';
import { isMobile } from 'react-device-detect';
import '../../styles/views/loginPage/loginPage.scss';

export const LoginPage: FC = observer(() => {
  const loginViewModel = useViewModel(LoginViewModel);
  const profileViewModel = useViewModel(ProfileViewModel);

  const [loginValidationError, setLoginValidationError] = useState(false);
  const [passValidationError, setPassValidationError] = useState(false);
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  /**  используем как заглушку вместо запроса на бэк пока что */
  const backValidation = async () => {
    await loginViewModel.signIn(login, password);
    if (loginViewModel.authorized) {
      profileViewModel.updateSettings();
      profileViewModel.setTimeZone();
    } else {
      setLoginValidationError(true);
      setPassValidationError(true);
    }
  };

  const keyDownHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && login && password) {
      event.preventDefault();
      backValidation();
    }
  };

  const onChangeLogin = (value: string) => onChangeWithValidation(
    value, setLogin, validator, setLoginValidationError,
  );

  const onChangePassword = (value: string) => onChangeWithValidation(
    value, setPassword, validator, setPassValidationError,
  );

  return (
    <div className="login-page">
      <div className="form">
        <LoginLogo allClassName={setClass('login-logo', isMobile && 'mobile')} />
        <div className="input-wrapper login">
          <Input
            value={login}
            error={loginValidationError}
            variant="rounded"
            placeholder="Введите логин"
            label="Логин"
            maxLength={64}
            onChange={onChangeLogin}
            autoFocus
            onKeyDown={keyDownHandler}
          />
        </div>

        <div className="input-wrapper pass">
          <InputPassword
            value={password}
            error={passValidationError}
            onChange={onChangePassword}
            onKeyDown={keyDownHandler}
          />
        </div>

        <Button
          title="Войти"
          className="medium-short"
          disabled={!(login && password)}
          onClick={backValidation}
        />
      </div>
      <Version />
    </div>
  );
});
